import PermissionManager from '@videotools/js/logic/permissions/permission-manager';

const initialState = () => {
};

const pm = new PermissionManager();

const getters = {
	isGuest: (state, getters, rootState, rootGetters) => {
		return pm.isGuest({ tagGroup: rootGetters['tagGroups/selectedTagGroup'] });
	},
	canViewTagCenter: (state, getters, rootState, rootGetters) => {
		return pm.canViewTagCenter({ tagGroup: rootGetters['tagGroups/selectedTagGroup'] });
	},
	canViewTagGroupSection: (state, getters, rootState, rootGetters) => (section) => {
		return pm.canViewTagGroupSection({
			tagGroup: rootGetters['tagGroups/selectedTagGroup'],
			section,
		});
	},
	canEditEventTag: (state, getters, rootState, rootGetters) => (eventTag) => {
		return pm.canEditEventTag({
			tagGroup: rootGetters['tagGroups/selectedTagGroup'],
			eventTag,
		});
	},
	canCreateTagGroups: (state, getters, rootState, rootGetters) => {
		return pm.canCreateTagGroups({
			defaultTagGroup: rootGetters['tagGroups/defaultTagGroup'],
		});
	},
	canEditTagGroups: (state, getters, rootState, rootGetters) => {
		// same permissions as with create tag groups
		return pm.canCreateTagGroups({
			defaultTagGroup: rootGetters['tagGroups/defaultTagGroup'],
		});
	},

	canUseMultiFormatTool: (state, getters, rootState, rootGetters) => {
		const eventPermissions = rootGetters['event/eventPermissions'];
		return pm.canUseMultiFormatTool(eventPermissions);
	},

	canUseHighlightTool: (_state, _getters, _rootState, rootGetters) => {
		// all users who can view the tag center can use the highlight tool
		return pm.canViewTagCenter({ tagGroup: rootGetters['tagGroups/selectedTagGroup'] });
	},

	canUseAnalyzeTool: (_state, _getters, _rootState, _rootGetters) => {
		return false;
	},

	canUpdateTagTemplates: (_state, _getters, _rootState, rootGetters) => {
		const eventPermissions = rootGetters['event/eventPermissions'];
		return pm.canUpdateTagTemplates(eventPermissions);
	},

	canCreateHighlightRule: (_state, _getters, _rootState, rootGetters) => {
		const eventPermissions = rootGetters['event/eventPermissions'];
		return pm.canCreateHighlightRule(eventPermissions);
	},

	canManageGraphics: (_state, _getters, _rootState, rootGetters) => {
		const eventPermissions = rootGetters['event/eventPermissions'];
		return pm.canManageGraphics(eventPermissions);
	},
};

export default {
	namespaced: true,
	state:      initialState(),
	getters,
};
